import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

/**
 * Search + single-select filter + primary action, in a card.
 *
 * Shared by the Road and Water catalog modes so the two cannot drift apart.
 * Presentational only — every piece of state lives in the parent mode.
 */
export default function CatalogToolbar({
  searchLabel, searchPlaceholder, searchValue, onSearchChange,
  filterLabel, filterValue, filterOptions = [], onFilterChange,
  actionLabel, onAction, actionDisabled = false, showAction = false,
}) {
  return (
    <div className="card mb-4">
      <div className="card-body">
        <Row>
          <Col md={4}>
            <Form.Group>
              <Form.Label>{searchLabel}</Form.Label>
              <Form.Control
                type="text"
                placeholder={searchPlaceholder}
                value={searchValue}
                onChange={onSearchChange}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>{filterLabel}</Form.Label>
              <Form.Control as="select" value={filterValue} onChange={onFilterChange}>
                {filterOptions.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={5} className="d-flex align-items-end justify-content-end">
            {showAction && (
              <button className="jv-btn jv-btn-primary" onClick={onAction} disabled={actionDisabled}>
                <i className="fa-sharp fa-regular fa-plus" /> {actionLabel}
              </button>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
}
